export default __webpack_public_path__ + "static/UpdatedRectanle-952e336265ffc06d11640f2b141741e9.jpg";